import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import Action from './Action'
import styled from 'styled-components'
import CompareBrokerImage from '../../../images/compare-broker.svg'
import NeedSummaryImage from '../../../images/need-summary.svg'
import GraphSolidImage from '../../../images/graph-solid.svg'
import FractionalSharesImage from '../../../images/fractional-shares.svg'
import AnnualReportProxyStatementDialog from './AnnualReportProxyStatementDialog'
import FractionalSharesDialog from './FractionalSharesDialog'
import {UserRoles} from '../../../constants'
import employeeService from '../../../services/Employee.service'

const Wrapper = styled.div`
  background-color: #eaeaea;
  width: 100%;
`

const Container = styled.section`
  width: 930px;
  padding: 25px 0 21px 0;
  margin: 0 auto;

  // Mobile version.
  @media (max-width: 768px) {
    padding: 24px 16px 24px 16px;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  > h2 {
    font-family: Lato-Light;
    font-size: 24px;
    font-weight: normal;

    color: #2b2b2b;
    line-height: 28px;
    padding: 0;
    margin: 0;
    padding-bottom: 5px;

    > a {
      font-family: Lato-Regular;
      font-size: 14px;
      color: #1d71bb;
      line-height: 16px;
      text-decoration: none;
      margin-top: 12px;
      float: right;
    }
  }

  > p {
      font-family: Lato-Regular;
      font-size: 14px;
      color: #2b2b2b;

      // Desktop version.
      @media (min-width: 768px) {
        line-height: 22px;
      }

      // Mobile version.
      @media (max-width: 768px) {
        line-height: 17px;
      }
    }

  > ul {
    padding: 0;
    margin: 0;
    display: inline-flex;

    > li {
      display: inline-block;
    }

    > li:nth-child(1),
    > li:nth-child(2) {
      margin-right: 30px;
    }

    // Mobile version.
    @media (max-width: 768px) {
      display: inline-block;

      > li {
        display: inline-block;
        margin-bottom: 22px;
        width: 100%;
      }
    }
  }
`
const Title = styled.h2`
  font-family: Lato-Light;
  font-size: 24px;
  font-weight: normal;

  color: #2B2B2B;
  line-height: 28px;
  padding: 0;
  margin: 0;
  padding-bottom: 5px;
`

export class PopularActions extends Component {

  constructor(props) {
    super(props);
    this.state = {
      annualReportDialogVisible: false,
      fractionalSharesDialogVisible: false
    };
  }

  onFractionalSharesClickButton = () => {
    this.setState({
      fractionalSharesDialogVisible: true
    })
  }

  onCloseFractionalSharesDialog = (e) => {
    this.setState({
      fractionalSharesDialogVisible: false})
  }

  onAnnualReeportClickButton = () => {
    this.setState({
      annualReportDialogVisible: true
    })
  }

  onCloseAnnualReportDialog = () => {
    this.setState({ annualReportDialogVisible: false })
  }

  render() {
    const { t, employee } = this.props;

    return (
      <Wrapper>
      <Container aria-labelledby="popularActionsHeading">
        <Title id="popularActionsHeading">{t('PopularActions.Title')}</Title>
        <ul>
          {!employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_NONE) && employeeService.showAvailableBrokers(employee) && !employeeService.isBrokerChoiceOne(employee) && (
            <li>
              <Action
                className = 'compare-brokers-link'
                imagem = {CompareBrokerImage}
                content ={ t('PopularActions.CompareBrokersContent')}
                buttonText = {t('PopularActions.CompareBrokersButton')}
                to = '/broker' />
            </li>
          )}
          {this.props.fractional_mode && employeeService.hasFractionalEligibleVest(employee) &&
            <li>
              <Action
                className = 'fractional-shares-link'
                imagem = {FractionalSharesImage}
                content = {t('PopularActions.FractionalSharesContent')}
                buttonText ={ t('PopularActions.FractionalSharesButton')}
                onDialog = {this.onFractionalSharesClickButton}
              />
            </li>
          }
          {!this.props.fractional_mode &&
            <li>
              <Action
                className = 'award-summary-link'
                imagem = {NeedSummaryImage}
                content = {t('PopularActions.NeedSummaryContent')}
                buttonText ={ t('PopularActions.NeedSummaryButton')}
                to = '/stock-awards'/>
            </li>
          }
          <li>
            <Action
              className = 'annual-report-link'
              imagem = {GraphSolidImage}
              content = {t('PopularActions.WantToSeeContent')}
              buttonText = {t('PopularActions.WantToSeeButton')}
              onDialog = {this.onAnnualReeportClickButton}
            />
          </li>
        </ul>
        <AnnualReportProxyStatementDialog visible={this.state.annualReportDialogVisible} onCloseDialog={this.onCloseAnnualReportDialog} />
        <FractionalSharesDialog
          employee={employee}
          vests={employeeService.getUpcomingVests(employee.awards)}
          visible={this.state.fractionalSharesDialogVisible}
          onCloseDialog={this.onCloseFractionalSharesDialog}
        />
      </Container>
      </Wrapper>
    )
  }
}

export default withTranslation('translations')(PopularActions);
